/**
 * Progressively rounds `num` to `decimalPlaces` places. This differs from other
 * rounding methods out there such as lodash's, which are not progressive. For example,
 * `(0.149).toFixed(1)` and lodash `_.round(0.149, 1)` both return `0.1`, but this
 * function rounds `0.149` to `0.15` and then `0.15` to `0.2` and returns `0.2`.
 */
export function decimalRound(num: number, decimalPlaces: number = 0): number {
    const integralAndFractionalSplit = String(num).split("."),
        allDecimalPlaces =
            integralAndFractionalSplit.length > 1 ? integralAndFractionalSplit[1].length : 0;

    for (let i = allDecimalPlaces - 1; i >= decimalPlaces; --i) {
        num = Number(`${Math.round(Number(`${num}e${i}`))}e-${i}`);
    }

    return num;
}
